import { render, staticRenderFns } from "./modal-portfolio.component.vue?vue&type=template&id=90288622&scoped=true"
import script from "./modal-portfolio.component.vue?vue&type=script&lang=js"
export * from "./modal-portfolio.component.vue?vue&type=script&lang=js"
import style0 from "./modal-portfolio.component.vue?vue&type=style&index=0&id=90288622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90288622",
  null
  
)

export default component.exports